import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Accessibility, Cloudinary } from 'core/services';

@Component({
    selector: 'xm-notification-banner',
    styleUrls: ['./notification.scss'],
    templateUrl: './notification.html',
    standalone: false
})
export class XmNotificationBanner implements OnChanges, OnInit {
    @Input() public pageData: CmsNotificationBanner;
    @Input() public isVisible: boolean;
    @Output() public closeBanner: EventEmitter<boolean> = new EventEmitter<boolean>();

    public closeIconOptions: MediaImageOptions;
    public displayCloseIcon: boolean = false;

    private accessibility: Accessibility;

    constructor(accessibility: Accessibility) {
        Object.assign(this, { accessibility });
    }

    public ngOnInit(): void {
        if (this.pageData.closeIcon) {
            this.displayCloseIcon = true;
            this.closeIconOptions = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.closeIcon)
            };
        }
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.isVisible) {
            if (this.pageData.header) {
                this.accessibility.focusHash('notification-header');

                return;
            }

            this.accessibility.focusHash('notification-description');
        }
    }

    public close(): void {
        this.closeBanner.emit(true);
    }
}
